import { useState } from "react";

// Real app captures of a strength session and an endurance session, with a
// segmented toggle to show one at a time. The screenshots ship with their own
// device frame, so they render frameless on the white page.
const SHOTS = [
  { key: "strength", label: "Strength", file: "train-strength.webp", alt: "Strength session in the app — sets, reps and working weights from your 1RMs" },
  { key: "endurance", label: "Endurance", file: "train-endurance.webp", alt: "Endurance session in the app — warmup, work and cooldown with target paces" },
] as const;

export default function TrainingShots() {
  const [active, setActive] = useState<(typeof SHOTS)[number]["key"]>("strength");

  return (
    <div className="w-full flex flex-col items-center" style={{ maxWidth: 340 }}>
      {/* Segmented toggle */}
      <div
        className="inline-flex p-1 mb-8"
        style={{
          background: "var(--mk-panel)",
          border: "1px solid var(--mk-line-2)",
          borderRadius: 12,
        }}
      >
        {SHOTS.map((s) => {
          const on = s.key === active;
          return (
            <button
              key={s.key}
              onClick={() => setActive(s.key)}
              className="mk-label transition-colors"
              style={{
                padding: "9px 22px",
                borderRadius: 9,
                fontSize: 11,
                color: on ? "#ffffff" : "var(--mk-muted)",
                background: on ? "#2747f0" : "transparent",
              }}
              aria-pressed={on}
            >
              {s.label}
            </button>
          );
        })}
      </div>

      {/* Stacked images — cross-fade between the two */}
      <div className="relative w-full">
        {SHOTS.map((s) => {
          const on = s.key === active;
          return (
            <img
              key={s.key}
              src={`/screens/${s.file}`}
              alt={s.alt}
              loading="lazy"
              className="w-full block"
              style={{
                position: on ? "relative" : "absolute",
                inset: 0,
                opacity: on ? 1 : 0,
                transition: "opacity 0.35s ease",
                pointerEvents: on ? "auto" : "none",
              }}
              onError={(e) => {
                (e.currentTarget as HTMLImageElement).style.visibility = "hidden";
              }}
            />
          );
        })}
      </div>
    </div>
  );
}
